import { Button, ConfirmationModal, Dropdown } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import Actions from 'actions'
import { Menu } from 'antd'
import { NAMESPACE } from 'locale'
import { shiftPasswordsConstants } from 'locale/shiftPasswords'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import DotsButton from 'screens/Residents/screens/ResidentsGoalsScreen/components/DotsMenu/DotsMenu'
import styled from 'styled-components'

export const ShiftPasswordItem = ({ onDelete, onManage, shift, testId }) => {
  const { t } = useTranslation(NAMESPACE.SHIFT_PASSWORDS)

  if (!shift) return null

  return (
    <ActionsWrapper
      onClick={(e) => e.stopPropagation()}
      data-testid={testId ? `${testId}-actions` : undefined}
    >
      <Button
        onClick={() => onManage(shift)}
        variant="default"
        data-cy="btn-manage"
        data-testid={testId ? `${testId}-manage-button` : undefined}
      >
        {t(shiftPasswordsConstants.MANAGE)}
      </Button>
      <Dropdown
        overlay={
          <Menu data-testid={testId ? `${testId}-actions-menu` : undefined}>
            <ConfirmationModal
              localisation={{
                cancelText: t(shiftPasswordsConstants.CANCEL),
                confirmText: t(shiftPasswordsConstants.DELETE),
                title: t(shiftPasswordsConstants.DELETING_PASSWORD)
              }}
              modalContent={
                <ModalContentWrapper>
                  <Text level={1}>
                    {t(shiftPasswordsConstants.DELETE_PASSWORD_CONFIRM)}
                  </Text>
                  <StyledText level={1}>
                    {t(shiftPasswordsConstants.ARE_YOU_SURE_CONTINUE)}
                  </StyledText>
                </ModalContentWrapper>
              }
            >
              <Menu.Item
                key="delete"
                onClick={() => onDelete(shift.id)}
                data-cy="btn-delete"
                data-testid={testId ? `${testId}-delete-button` : undefined}
              >
                {t(shiftPasswordsConstants.DELETE)}
              </Menu.Item>
            </ConfirmationModal>
          </Menu>
        }
        trigger={['click']}
        placement="bottomRight"
      >
        <DotsButton
          data-testid={testId ? `${testId}-dots-button` : undefined}
        />
      </Dropdown>
    </ActionsWrapper>
  )
}

const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledText = styled(Text)`
  font-weight: 500;
`

ShiftPasswordItem.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onManage: PropTypes.func.isRequired,
  shift: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  onManage: (shift) => {
    const id = 'editShift'
    dispatch(Actions.openModal({ modalId: id }))
    dispatch(
      Actions.addForm({
        formId: id,
        initial: {
          id: shift.id,
          title: shift.title,
          startTime: shift.startTime,
          endTime: shift.endTime,
          length: shift.length
        }
      })
    )
  }
})

export default connect(null, mapDispatchToProps)(ShiftPasswordItem)
